import { useEffect } from 'react'
import { useRouter } from 'next/navigation'

import { captureError } from '../../../instrumentation-client'

import { ErrorView } from './ErrorView'

interface UnknownErrorProps {
  error: any
  fullScreen?: boolean
}

export function UnknownError({ error, fullScreen }: UnknownErrorProps) {
  const router = useRouter()

  useEffect(() => {
    captureError(error)
  }, [error])

  return <ErrorView error={error} onReload={() => router.refresh()} fullScreen={fullScreen} />
}
